<template>
  <div class="faq-page">
    <navbar
      is-blur="blur blur-rounded my-3 py-2 start-0 end-0 mx-4 shadow"
      btn-background="bg-gradient-success"
      :dark-mode="true"
    />
    <div class="min-height-300 bg-primary position-absolute w-100"></div>
    <page-hero
      title="FAQ"
      subtitle="Questions fréquentes"
      description="Trouvez rapidement des réponses à vos questions."
      :showBreadcrumb="true"
    />
    <main class="main-content position-relative border-radius-lg">
      <div class="container-fluid py-4">
        <div class="row">
          <div class="col-12 mb-4">
            <div class="card">
              <div class="card-header pb-0">
                <div class="input-group">
                  <span class="input-group-text"><i class="fas fa-search"></i></span>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Rechercher une question..."
                    v-model="searchQuery"
                    @input="filterQuestions"
                  >
                </div>
              </div>
              <div class="card-body p-3">
                <div class="accordion" id="faqAccordion">
                  <div 
                    v-for="(section, sIndex) in filteredSections" 
                    :key="section.title"
                    class="mb-4"
                  >
                    <h5 class="font-weight-bolder mb-3">{{ section.title }}</h5>
                    <div 
                      v-for="(item, qIndex) in section.questions" 
                      :key="qIndex"
                      class="accordion-item border-radius-lg mb-3"
                    >
                      <h2 class="accordion-header">
                        <button
                          class="accordion-button border-radius-lg collapsed"
                          type="button"
                          :data-bs-toggle="'collapse'"
                          :data-bs-target="'#faq-' + sIndex + '-' + qIndex"
                          aria-expanded="false"
                        >
                          {{ item.question }}
                        </button>
                      </h2>
                      <div
                        :id="'faq-' + sIndex + '-' + qIndex"
                        class="accordion-collapse collapse"
                        :data-bs-parent="'#faqAccordion'"
                      >
                        <div class="accordion-body text-sm" v-html="item.answer">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    
    <!-- Composants requis -->
    <testimonials-section />
    <cta-section />
    <app-footer />
  </div>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/PageLayout/Footer.vue";
import PageHero from '@/components/PageHero.vue';
import TestimonialsSection from '@/components/TestimonialsSection.vue';
import CtaSection from '@/components/CtaSection.vue';

export default {
  name: 'FaqPage',
  components: {
    Navbar,
    AppFooter,
    PageHero,
    TestimonialsSection,
    CtaSection
  },
  data() {
    return {
      searchQuery: '',
      sections: [
        {
          title: "Questions générales",
          questions: [
            {
              question: "Qu'est-ce que Nolido ?",
              answer: "Nolido est une entreprise spécialisée dans les solutions de gestion d'entreprise et la transformation digitale. Nous proposons trois services principaux : N'Business, N'Lite et N'Consulting."
            },
            {
              question: "Comment choisir la solution adaptée à mon entreprise ?",
              answer: "Nous vous recommandons de prendre contact avec nos équipes qui pourront analyser vos besoins et vous orienter vers la solution la plus adaptée. Vous pouvez également consulter nos pages dédiées à chaque solution pour plus d'informations."
            }
          ]
        },
        {
          title: "N'Business",
          questions: [
            {
              question: "Quelles sont les fonctionnalités principales de N'Business ?",
              answer: "N'Business offre une suite complète de gestion incluant :<ul><li>Gestion commerciale</li><li>Comptabilité</li><li>Gestion des stocks</li><li>CRM</li><li>Reporting avancé</li></ul>"
            },
            {
              question: "N'Business est-il adapté aux grandes entreprises ?",
              answer: "Oui, N'Business est particulièrement adapté aux moyennes et grandes entreprises ayant des besoins complexes en termes de gestion et d'organisation."
            }
          ]
        },
        {
          title: "N'Lite",
          questions: [
            {
              question: "N'Lite est-il facile à prendre en main ?",
              answer: "Oui, N'Lite a été conçu pour être intuitif et facile à utiliser. Une formation initiale est proposée et notre support est disponible pour vous accompagner."
            },
            {
              question: "Puis-je migrer de N'Lite vers N'Business plus tard ?",
              answer: "Oui, nous avons prévu un parcours de migration simple de N'Lite vers N'Business lorsque votre entreprise se développe."
            }
          ]
        },
        {
          title: "N'Consulting",
          questions: [
            {
              question: "Comment se déroule une mission de consulting ?",
              answer: "Une mission N'Consulting se déroule en plusieurs phases :<ul><li>Audit initial</li><li>Définition des objectifs</li><li>Élaboration de la stratégie</li><li>Mise en œuvre</li><li>Suivi et optimisation</li></ul>"
            },
            {
              question: "Quelle est la durée moyenne d'une mission ?",
              answer: "La durée varie selon vos besoins et l'ampleur du projet. Elle peut aller de quelques semaines à plusieurs mois."
            }
          ]
        },
        {
          title: "Support et assistance",
          questions: [
            {
              question: "Comment contacter le support technique ?",
              answer: "Notre support technique est disponible par email à support@nolido.com ou par téléphone au +33 1 23 45 67 89, du lundi au vendredi de 9h à 18h."
            },
            {
              question: "Proposez-vous des formations ?",
              answer: "Oui, nous proposons des formations personnalisées pour tous nos produits, en présentiel ou à distance."
            }
          ]
        }
      ]
    }
  },
  computed: {
    filteredSections() {
      if (!this.searchQuery) {
        return this.sections
      }

      const query = this.searchQuery.toLowerCase()
      return this.sections.map(section => {
        const filteredQuestions = section.questions.filter(item => {
          return item.question.toLowerCase().includes(query) ||
                 item.answer.toLowerCase().includes(query)
        })
        return filteredQuestions.length ? {
          ...section,
          questions: filteredQuestions
        } : null
      }).filter(section => section !== null)
    }
  },
  methods: {
    filterQuestions() {
      // La filtration est gérée par le computed property
      // Cette méthode est conservée pour d'éventuelles extensions futures
    }
  }
}
</script>

<style>
.accordion-button:not(.collapsed) {
  background-color: #f8f9fa;
  color: #344767;
}

.accordion-button:focus {
  box-shadow: none;
  border-color: rgba(0, 0, 0, 0.125);
}

.accordion-item {
  background-color: white;
  border: 1px solid #eee;
}

.accordion-button {
  padding: 1rem;
  font-weight: 600;
}

.accordion-body {
  padding: 1rem;
  color: #67748e;
}

.accordion-body ul {
  padding-left: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.accordion-body li {
  margin-bottom: 5px;
}
</style>
